export default `
<div class="navigate-prev-next">
  <ul>
    <li><a ng-class="{inactive: !$ctrl.prevItem}" ng-attr-title="{{$ctrl.prevItem.title}}" ng-href="{{$ctrl.getHref($ctrl.prevItem)}}" aria-label="previous project"><i class="material-icons">chevron_left</i></a></li>
    <li><a ng-class="{inactive: !$ctrl.nextItem}" ng-attr-title="{{$ctrl.nextItem.title}}" ng-href="{{$ctrl.getHref($ctrl.nextItem)}}" aria-label="next project"><i class="material-icons">chevron_right</i></a></li>
  </ul>
  <ng-transclude></ng-transclude>
</div>
`;
